import React from 'react'
import Avatar from '@material-ui/core/Avatar'

function Header() {
	return (
		<div>
			<Avatar src='https://randomuser.me/api/portraits/women/68.jpg' />
		</div>
	)
}

export default Header
